module.exports = __webpack_public_path__ + "img/symbol_1.2dde3345.png";